import type { ReactNode } from "react"

import { LoadingSection } from "@/components/loading-section"
import { useRoutes } from "@/contexts/use-routes"

/**
 * Guard component that ensures routes are loaded before rendering children.
 * Displays a loading state while routes are being fetched from settings.
 *
 * This prevents components from rendering before routes are available,
 * which would cause useCurrentSessionType() to fail.
 */
export function RouteReadyGuard({ children }: { children: ReactNode }) {
  const { routes } = useRoutes()

  // Show centered loading state while routes are being loaded from settings
  if (routes.length === 0) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <LoadingSection />
      </div>
    )
  }

  return <>{children}</>
}
